export default [
  {
    path: "/manageMain",
    name: "经营主体管理",
    component: () => import("../views/manageMain/index.vue"),
  },
  {
    path: "/manageMainExamine",
    name: "经营主体管理",
    component: () => import("../views/manageMain/examineList/index.vue"),
  },
];
